var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.stepProgress.data && _vm.stepProgress.data.length != 0
    ? _c("div", { staticClass: "progress" }, [
        _vm.stepProgress.mailNo
          ? _c("div", { staticClass: "step-title" }, [
              _vm._v(
                _vm._s(_vm.stepProgress.expTextName + _vm.stepProgress.mailNo)
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "step-list" }, [
          _c(
            "ul",
            _vm._l(_vm.stepProgress.data, function (item, index) {
              return _c(
                "li",
                { key: index, class: [index == 0 ? "current-active" : ""] },
                [
                  _c("div", { staticClass: "step-time" }, [
                    _vm._v(_vm._s(item.dataTime)),
                    _c("br"),
                    _vm._v(_vm._s(item.year)),
                  ]),
                  _c("div", { staticClass: "step-content" }, [
                    _vm._v(_vm._s(item.context)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ])
    : _c("div", [
        _c("h5", [
          _vm._v(
            _vm._s(_vm.stepProgress.data ? _vm.stepProgress.msg : "暂无信息")
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }